var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconScale = function SvgIconScale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-Scale_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.563 34.792c.517 0 .937-.42.937-.937V.938A.937.937 0 0 0 63.562 0H13.087a.937.937 0 0 0-.937.938v37.89H1.438a.937.937 0 0 0-.938.937v23.297c0 .518.42.938.938.938h9.606a.938.938 0 0 0 0-1.875H2.375V40.703h9.774v10.71c0 .519.42.938.937.938h10.711v9.774H15.13a.938.938 0 0 0 0 1.875h9.606c.518 0 .938-.42.938-.938v-10.71h37.89c.517 0 .937-.42.937-.938V37.94a.937.937 0 1 0-1.875 0v12.536H14.024V1.875h48.601v31.98c0 .518.42.938.938.938Z",
    fill: "#202931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.737 23.245a2.897 2.897 0 0 0 2.894-2.894V6.762c0-1.567-1.313-2.893-2.879-2.893H44.15a2.897 2.897 0 0 0-2.894 2.893 2.897 2.897 0 0 0 2.894 2.894h6.602l-22.24 22.239a2.9 2.9 0 0 0 .002 4.094c1.364 1.128 2.728 1.128 4.092-.001l9.82-9.819a.937.937 0 1 0-1.327-1.326l-9.817 9.818c-.481.398-.962.399-1.443.001a1.021 1.021 0 0 1 0-1.442l23.84-23.838c.739-.664.374-1.6-.663-1.6h-8.866a1.02 1.02 0 0 1 0-2.038h13.603c.55 0 1.004.476 1.004 1.019V20.35a1.02 1.02 0 0 1-2.037 0v-8.866c-.052-1.006-.937-1.298-1.6-.663L43.985 21.955a.937.937 0 1 0 1.326 1.325l9.532-9.532v6.603a2.897 2.897 0 0 0 2.893 2.894Z",
    fill: "#14D64D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-Scale_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h64v64H0z"
  })))));
};

export default SvgIconScale;